class ProgressBar extends HTMLElement {
  constructor() {
    super();

    this.progress = this.querySelector("progress");
  }

  updateProgressBar(value) {
    let valueInt = parseInt(value, 10);

    if (isNaN(valueInt) || valueInt < 0) {
      valueInt = 0;
    } else if (valueInt > 100) {
      valueInt = 100;
    }

    this.progress.setAttribute("value", valueInt);
  }
}

if (!window.customElements.get("progress-bar")) {
  window.customElements.define("progress-bar", ProgressBar);
}
